'use client'

import Link from 'next/link'
import { Settings2 } from 'lucide-react'
import { Button } from './button'

interface ModuleSettingsLinkProps {
    /** Full path including tenant slug, e.g. `/${tenant}/settings/yahrzeit` */
    href: string
    /** Button label, e.g. "Settings" or "Tag settings" */
    label: string
    className?: string
}

/**
 * ModuleSettingsLink — Tier-2 contextual settings entry for module headers.
 * Deep-links from a module page to that module's single settings definition
 * in the hub (one source of truth: no setting form is ever duplicated in a
 * module). Place in PageHeader's `secondaryActions` slot.
 */
export function ModuleSettingsLink({ href, label, className }: ModuleSettingsLinkProps) {
    return (
        <Button variant="secondary" asChild className={className}>
            <Link href={href}>
                <Settings2 className="h-4 w-4" />
                {label}
            </Link>
        </Button>
    )
}
